import { Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, InputAdornment, Stack, TextField, Typography } from '@mui/material'
import { handlePaste, validateEmail, ValidateInt, validateTextKey } from '../../../../core/validator/Validator'
import { rqx } from '../../../../core/request/API'
import { env } from '../../../../core/Env'
import { Close } from '@mui/icons-material';
import moment from 'moment';
import { useState } from 'react';

const Setup = ({add, setAdd, form, setForm, tool_state, dfltForm, setList, subtype}) => {
    const { __SESSION, userId} = tool_state
    const [existing, setExisting] = useState({email: false, contact_no: false})
    const handleDialogAction = (action) => {
        if (action === 'cancel') {
            setAdd(false)
        }else{
            handleSaving()
        }
    }
    
    const handleChange = (e) => {
        const { name, value } = e.target
        let filteredVal = value
        if (name === 'email' || name === 'contact_no') {
            setExisting((p) => (
                {...p, [name] : false}
            ))
        }
        if (name === 'company_name') {
            filteredVal = value.replace(/[^a-zA-Z0-9\s\.\-]/g, '')
        }
        if (name === 'address') {
            filteredVal = value.replace(/[^a-zA-Z0-9\s,\.\-#]/g, '')
        }
        setForm((p) => ({...p, [name] : filteredVal}))
    }
    
    const handleSaving = () => {
        const errors = {};
        // validate required.
        const required = [ 'email', 'last_name', 'first_name', 'contact_no',]
        required.forEach(field => {
            if (!form[field] || form[field].trim() === "") {
                errors[field] = `${field} is required.`
            }
        });
        if (Object.keys(errors).length > 0 || !validateEmail(form.email) || form.contact_no.length !== 10 || existing.email || existing.contact_no) {
            console.log("Validation Faield", errors)
            setForm((p) => (
                {...p, error : true}
            ))
            return
        }
        setForm((p) => ({...p, error: false, confirmation: true}))
        console.log("Saving data:", form);
    }

    const handleConfirm = async() => {
        setForm((p) => (
            {...p, btnLoader: true}
        ))
        const body = {
            contact_no: form.contact_no,
            birthdate: form.birthdate,
            last_name: form.last_name,
            first_name: form.first_name,
            company_name: form.company_name, 
            email: form.email,
            address: form.address,
            user_id: userId.data,
            company_id : __SESSION.data.uaccess[0].company_id,
            type: subtype
        }
        const c = await rqx.post(`<<tool>>/${env()}/contact/create`, body) 
        if (c.message === "Contact already exists") {
            setForm((p) => ({...p, error: false, confirmation: false, btnLoader: false}))
            setExisting((p) => (
                {...p, email: !!c.data?.email, contact_no: !!c.data?.mobile_number }
            ))
        }else if (c.message === "success") {
            setForm(dfltForm)
            setList((p) => [
                { mobile_number: form.contact_no, company_name: form.company_name, email: form.email, first_name: form.first_name, last_name: form.last_name, source:"Manually Added", active: 0, },
                ...p
            ])
            handleClose()
            // add here the update for list or rerun the api read list.
        }
    }

    const handleClose = () => {
        setAdd(false)
    }
    
    return (
        <>
            <Dialog open={add} onClose={handleClose} fullWidth maxWidth="md" scroll='paper'>
                <DialogTitle >
                   <Box position="relative">
                        <Typography variant='h6' textAlign="center"> {form.method === "create" ? "Add" : "View"} Email Contact </Typography>
                        <IconButton sx={{position: "absolute", right: 8, top: 0}} onClick={handleClose}>
                            <Close />
                        </IconButton>
                   </Box>
                </DialogTitle>
                <DialogContent dividers sx={{p: 3}}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={4}>
                            <Stack spacing={1}>
                                <Stack direction="row" gap="4px" alignItems="center">
                                    <Typography variant='body1'>Email</Typography>
                                    <Typography color="#f44336">*</Typography>
                                </Stack>
                                <TextField name="email" type='email' size='small' onChange={handleChange} 
                                    error={form.error && (form.email.trim() === "" || !validateEmail(form.email)) || existing.email} 
                                    helperText={(form.error && (form.email.trim() === "" || !validateEmail(form.email)) && 'Invalid Email') || (existing.email && "Email already exists")}
                                    value={form.email}
                                />
                            </Stack>
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <Stack spacing={1}>
                                <Stack direction="row" gap="4px" alignItems="center">
                                    <Typography variant='body1'>Last Name</Typography>
                                    <Typography color="#f44336">*</Typography>
                                </Stack>
                                <TextField name="last_name" size='small' onChange={handleChange}
                                    error={form.error && form.last_name.trim() === ""}
                                    onKeyDown={validateTextKey}
                                    onPaste={handlePaste}
                                    value={form.last_name}
                                />
                            </Stack>
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <Stack spacing={1}>
                                <Stack direction="row" gap="4px" alignItems="center">
                                    <Typography variant="body1">First Name</Typography>
                                    <Typography color="#f44336">*</Typography>
                                </Stack>
                                <TextField name="first_name" size='small' onChange={handleChange} 
                                    error={form.error && form.first_name.trim() === ""}
                                    onKeyDown={validateTextKey}
                                    onPaste={handlePaste}
                                    value={form.first_name}
                                />
                            </Stack>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Stack spacing={1}>
                                <Stack direction="row" gap="4px" alignItems="center">
                                    <Typography variant="body1">Contact No.</Typography>
                                    <Typography color="#f44336">*</Typography>
                                </Stack>
                                <TextField name="contact_no" size='small' placeholder="9562749314" onChange={handleChange} 
                                    error={(form.error && form.contact_no.trim() === "") || existing.contact_no || form.contact_no.length !== 10}
                                    onKeyDown={(e) => ValidateInt(e)}
                                    onPaste={handlePaste}
                                    value={form.contact_no}
                                    inputProps={{ maxLength: 10 }}
                                    helperText={(form.contact_no.length !== 10 && "Invalid Contact No.") || (existing.contact_no && "Contact No. already exists")}
                                    InputProps={{ startAdornment: ( <InputAdornment position="start">
                                        <Typography align="left" ml="8px" sx={{ color: "#5B6167", fontSize: "14px" }}>+63</Typography>
                                    </InputAdornment> ) }}
                                />
                            </Stack>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Stack spacing={1}>
                                <Typography variant="body1">Birthdate</Typography>
                                <TextField type="date" name="birthdate" size='small' onChange={handleChange} value={form.birthdate} 
                                    inputProps={{
                                        max: moment().format('YYYY-MM-DD') // Disallow future dates
                                    }}
                                />
                            </Stack>
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <Stack spacing={1}>
                                <Typography variant="body1">Company</Typography>
                                <TextField name="company_name" size='small' onChange={handleChange} value={form.company_name} />
                            </Stack>
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <Stack spacing={1}>
                                <Typography variant="body1">Address</Typography>
                                <TextField name="address" size='small' onChange={handleChange} value={form.address} />
                            </Stack>
                        </Grid>
                    </Grid>
                </DialogContent>
                {
                    form.method !== "view" &&
                        <DialogActions sx={{justifyContent: 'center', p: 2}} >
                            <Box display="flex" gap={2} width="100%" maxWidth={300}>
                                <Button variant='outlined' onClick={() => handleDialogAction('cancel')}
                                    sx={{flex: 1}}
                                >
                                    Cancel
                                </Button>
                                <Button variant='contained' onClick={() => handleDialogAction('save')}
                                    sx={{flex: 1}}
                                >
                                    Save
                                </Button>
                            </Box>
                        </DialogActions>
                }
            </Dialog>
            {/* CONFIRMATION MODAL SAVING */}
            {/* onClose={handlerClose} */}
            <Dialog open={form.confirmation} >
                <DialogTitle sx={{ fontSize: '18px', fontWeight: 600 }}>Save Contact Details?</DialogTitle>
                <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                    <Typography sx={{ fontSize: '14px', fontWeight: 400 }}>Are you sure you want to save this contact?</Typography>
                </DialogContent>
                <DialogActions>
                    <Button variant='outlined' onClick={() => setForm((p) => ( {...p, confirmation : false} ))} disabled={form.btnLoader}>
                        Cancel
                    </Button>
                    <Button variant="contained" onClick={handleConfirm} disabled={form.btnLoader}>
                        {form.btnLoader ? <CircularProgress size={24.5} />  : "Save"}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default Setup